module.exports = __webpack_public_path__ + "img/vps4.008ffd9.png";